import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { saveAs } from 'file-saver';

import { useGetEventSummary, useExportEventGuests } from 'legacy/events/hooks';
import ModalBase, { BaseModalProps } from '../ModalBase/ModalBase';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import styles from './ExportGuests.module.scss';

interface ExportGuestsProps {
  _id: string;
  events: any;
  baseModalProps: BaseModalProps;
}

const ExportGuests = ({ _id: eventId, events, baseModalProps }: ExportGuestsProps) => {
  const event = events[eventId];

  const { refetch: fetchExcelData, isLoading } = useExportEventGuests(eventId, {
    isEnabled: false
  });

  const onClick = async () => {
    const { data: rawData } = await fetchExcelData();
    const blob = new Blob([rawData], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
    });

    saveAs(blob, 'Bounce-Guests.xlsx');
  };

  const { data: eventSummary } = useGetEventSummary(
    eventId,
    event?.isOrganizer
  );
  const scannedGuests = eventSummary?.totals?.scannedGuests || 0;
  const totalTicketsSold = eventSummary?.totals?.ticketsSold || 0;

  return (
    <ModalBase
      baseModalProps={baseModalProps}
      back_img="Back"
      contentClassName="basic"
    >
      <div className={classnames(styles.ExportGuests, 'component')}>
        <i className="fas fa-file-export" />
        <h2 className="modalTitle">Export Event Guests</h2>
        <div className={styles.grid}>
          <div className={styles.sectionLabel}>Number of Tickets Sold</div>
          <div>{totalTicketsSold}</div>
          <div className={styles.sectionLabel}>Number of Scanned Tickets</div>
          <div>{scannedGuests}</div>
        </div>
        <Button
          className={styles.download}
          onClick={onClick}
          type={ButtonType.Primary}
          loading={isLoading}
        >
          Export to Excel
        </Button>
      </div>
    </ModalBase>
  );
};

interface StateProps {
  events: any;
}

const mapStateToProps = (state: any): StateProps => ({
  events: state.events.events
});

export default connect(mapStateToProps)(ExportGuests);
